export class ContactPhone {
    ContactPhoneId: number;
    ContactId: number;
    PhoneType: number;
    PhoneNumber: string;
    IsPrimary: boolean;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/model/crm/contact-phone.model.ts